export default __webpack_public_path__ + "static/media/convert_facebook_phone.58f5f40c.png";